import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import DarkMode from "../Component/DarkMode";
import { Button, Dropdown } from 'react-bootstrap';
import LogoMini from '../Component/Logo-mini';
import { API } from "../App"
import { toast } from 'react-toastify';
import Cookies from 'js-cookie'




const Header = ({ openSidebar }) => {

    const Navigate = useNavigate()
    const Cookieclear = async () => {
        console.log("in");
        const token = Cookies.get('jwt')
        const res = await API.post(`/logout`, {}, { headers: { "authorization": `Bearer ${token}` } })
        Cookies.remove('jwt')
        toast.success("Logout Sucesfully", { position: "bottom-right", autoClose: 500 })
        Navigate("/")

    }

    return (
        <>
            <header className="sidebar-header">
                <div className="header-left-menu">
                    <Link to="/" className='d-xl-none'>
                        <LogoMini />
                    </Link>
                </div>
                <div className="header-right-menu">
                    <DarkMode />
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-autoclose-true">
                            <div className="user-menu">
                                <div className="user-img">
                                    <img src="../../../logo/app-logo.svg" alt="Fonts-Keyborad" className='auth-logo' />
                                </div>
                                <div className="user-name ms-2">
                                    <h6>Fonts-Keyboard</h6>
                                    <p>Admin</p>
                                </div>
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-menu dropdown-menu-end">
                            <Dropdown.Item>
                                <div className='Profile  dropDownBTN'><a href="" onClick={Cookieclear}>Logout</a></div>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button className="burger-btn d-xl-none" onClick={openSidebar}>
                        <i className='bx bx-menu fs-3'></i>
                    </Button>
                </div>
            </header>
        </>
    )
}

export default Header;